import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/suppliers/$supplierId/settings")({
  component: lazyRouteComponent(() => import("./+SupplierSettings")),
  beforeLoad: () => ({
    breadcrumb: "Settings",
  }),
});
